import type { WebDeviceFields } from './types';

function browserName(userAgent: string): string {
  if (userAgent.includes('Edg/')) return 'Edge';
  if (userAgent.includes('Firefox/')) return 'Firefox';
  if (userAgent.includes('Chrome/')) return 'Chrome';
  if (userAgent.includes('Safari/')) return 'Safari';
  return 'Browser';
}

function timeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}

/** Device fields so v2 stores this browser as a web session, not an Android phone. */
export function webDeviceFields(installationId: string): WebDeviceFields {
  const nav = typeof navigator !== 'undefined' ? navigator : undefined;
  const userAgent = nav?.userAgent || '';
  const browser = browserName(userAgent);
  const os = (nav?.platform || 'Web').slice(0, 40);

  return {
    installation_id: installationId,
    platform: 'web',
    device_manufacturer: 'Web',
    device_model: browser,
    device_display_name: `${browser} on ${os}`.slice(0, 80),
    os_version: os,
    language: (nav?.language || '').slice(0, 16),
    timezone: timeZone().slice(0, 64),
    app_version: 'web',
  };
}
